import {
    getAlertLayerBtnCancelTmpl,
    getAlertLayerBtnConfirmTmpl,
    getAlertLayerTmpl,
} from "./templates/html.template";
import Popup from "./base/Popup";
import {wait} from "../utils/util";
import {isVisible} from "smooth-scrollbar/geometry";
import { isA11yCheckVersion } from "../functions/a11y.ui";

/**
 * PopupAlert
 */
/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_template01.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_template01.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample01.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample01.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample02.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample02.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample03.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample03.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample04.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample04.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample05.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample05.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample06.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample06.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample07.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample07.html)
** [http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample08.html](http://172.20.160.28:9700/kbank_html_mmk/popup/popup_alert_sample08.html)
*/


class PopupAlert {
    popupAlert;
    /**
     * open
     * @param {object} options 
     * @example
     * message : 'msg'
     * subMessage :  'submsg'
     * legacyText : 'text'
     * code : 'errorcode'
     * banner : 'banner tag'
     * icoImg : 'icon tag'
     * btnCancel : 'cancel btn {text:'cancel', fn: callbackFn}
     * btnConfirm : 'confirm btn {text:'confirm', fn: callbackFn}
     * closeCallback : callbackFn
     * 
     * frontUI.alert.open({
     *       message: '1',
     *       btnCancel: {
     *           text: 'cancel',
     *           fn: function(){console.log(1);}
     *       },
     *       btnConfirm: {
     *           text: 'ok',
     *           fn: function(){console.log(2);}
     *       }
     *   })
     *
     *   frontUI.alert.open({
     *       message: '1',
     *       code: 'WERTY45678967890',
     *       bannerSrc: '../../resource/img/mmk/common/img_history02.jpg',
     *       btnCancel: {
     *           text: 'cancel',
     *           fn: function(){
     *               frontUI.alert.close();
     *           }
     *       },
     *       btnConfirm: {
     *           text: 'ok',
     *           fn: function(){
     *               frontUI.alert.close();
     *           }
     *       },
     *       closeCallback: function(){
     *           frontUI.alert.close();
     *       }
     *   })
     */
    async open({message, subMessage, legacyText, code, banner, icoImg, btnCancel, btnConfirm, closeCallback}){ // CHPFMTASK-1260 : legacyText
        this.popupAlert = new PopupAlertImpl();
        await this.popupAlert.open({message, subMessage, legacyText, code, banner, icoImg, btnCancel, btnConfirm, closeCallback});
    }
    /**
     * close
     * @example 
     * frontUI.alert.close()
     */
    close(){
        this.popupAlert && this.popupAlert.close();
    }
}
class PopupAlertImpl extends Popup {
    constructor(el, options) {
        super('popupAlert', el);

        this.init(el, options);
    }

    init(el, options) {
        this.popupInit(el, options);
    }

    render() {

    }

    openMotion() {
        if(isA11yCheckVersion()){
            const removeIdContent = document?.querySelector('#content-mmk');
            removeIdContent?.removeAttribute('aria-hidden');
        }

        this.openCommonMotion({
            cancelMotion: false,
            callback: () => {

            }
        });
    }

    closeMotion(cb = () => {}) {
        this.closeCommonMotion({
            cancelMotion: false,
            callback: () => {
                this.detachEvents();

                cb();
            }
        });
    }
     
    async open({message, subMessage, legacyText, code, banner, icoImg, btnCancel, btnConfirm, closeCallback}) {// CHPFMTASK-1260 : legacyText   추가 
        this.btnCancelFn = btnCancel && btnCancel.fn;
        this.btnConfirmFn = btnConfirm && btnConfirm.fn;
        this.closeCallback = closeCallback;
        const messageHTML = message;
        const subMessageHTML = subMessage;
        const legacyTextHTML = legacyText;
        const errorCodeHTML = code;
        const bannerSrcHTML = banner;
        const icoImgHTML = icoImg;
        const btnCancelHTML = btnCancel && getAlertLayerBtnCancelTmpl(btnCancel.text);
        const btnConfirmHTML = btnConfirm && getAlertLayerBtnConfirmTmpl(btnConfirm.text, btnConfirm.size);

        // 20220426 delay 제거
        // if ($('.popup-wrap .dimm').is(':visible')) {
        //     //await wait(250);
        // }
        //
        // if (this.$popupContainer.find('.ui-alert').length > 0) {
        //     //await wait(250);
        // }
        // CHPFMTASK-1260 : legacyTextHTML   추가
        this.$popup = $(getAlertLayerTmpl(messageHTML, subMessageHTML, legacyTextHTML, errorCodeHTML, bannerSrcHTML, icoImgHTML, btnCancelHTML, btnConfirmHTML));
        this.$popupContainer.append(this.$popup);
        this.$popup.attr('data-id', this.uiId);

        this.attachEvents();
        this.openMotion();

        if (typeof this.$popup.data('ui') === 'undefined') {
            this.$popup.data('ui', this)
        }
    }
    
    close() {
        this.closeMotion(() => {
            this.detachEvents();
        });
    }

    closeCallbackAction() {
        if (this.closeCallback && $.isFunction(this.closeCallback)) {
            this.closeCallback();
        } else {
            this.closeMotion();
        }
    }

    attachEvents() {
        // dimm 영역 클릭 시 팝업 닫힘
        // this.$popup.on(`click${this.eventId}`, (e) => {
        //     e.preventDefault();

        //     if (e.target === e.currentTarget) {
        //         this.closeCallbackAction();
        //     }
        // });

        if (this.btnCancelFn) {
            this.$popup.on(`click${this.eventId}`, '.ui-cancel', () => {

                if (!this.closeCallback) {
                    this.close();
                }

                this.btnCancelFn();
            });
        }

        if (this.btnConfirmFn) {
            this.$popup.on(`click${this.eventId}`, '.ui-confirm', () => {
                if (!this.closeCallback) {
                    this.close();
                }

                this.btnConfirmFn();
            });
        }
    }

    detachEvents() {
        if (this.$popup) {
            this.$popup.off(this.eventId);
            this.$popup.remove();
            this.$popup = undefined;
        }
    }

    destroy() {
        this.detachEvents();
    }
}

export default PopupAlert;
